<template>
  <div>
    <PFilePreview
        ref="filePreview"
        v-if="existing_file"
        :file="existing_file"
        :filename="existing_filename"
        :allow_delete="allow_delete"
        @delete="deleteFile"
    />
    <div class="mb-1 dropzone-wrap" v-if="!existing_file && !new_file || has_error" :class="{'danger': has_error}">
      <PFileDrop @dropped="onFileChosen"/>
      <div v-if="help_text" class="text-help mt-1">{{help_text }}</div>
    </div>
    <PFileUploader
        ref="fileUploader"
        v-if="new_file"
        :get_intent="get_intent"
        :allow_delete="allow_delete"
        :params="params"
        :input="new_file"
        @intent="$emit('update:value',$event)"
        @uploaded="$emit('uploaded',$event)"
        @error="has_error = true"
        @delete="deleteFile"
    />

    <PCropper
        ref="modalCropper"
        v-if="cropper && new_file && !has_error"
        :cropper-type="cropper"
        :file="new_file"
        @file-edited="onFileEdited"
        @dismiss="onCropperDismiss"/>
  </div>
</template>

<script>
import PFileDrop from "@/domain/core/components/upload/PFileDrop.vue";
import {props as uploader_props, methods as uploader_methods, DELETE_KEY} from "@/domain/core/components/uploader";
import PFileUploader from "@/domain/core/components/upload/PFileUploader.vue";
import PFilePreview from "@/domain/core/components/upload/PFilePreview.vue";
import PCropper from "@/domain/core/components/upload/PCropper.vue";
import fileUtils from "@/domain/core/utils/fileUtils";
import {cropperTypes} from "@/domain/core/constant/cropper";

export default {
  name: "PUploader",
  components: {PCropper, PFilePreview, PFileUploader, PFileDrop},
  props: {
    help_text: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    filename: {
      type: String,
      required: false
    },
    preview: {
      type: String,
      required: false
    },
    cropper: {
      type: String,
      required: false,
    },
    resize: {
      type: Object,
      required: false,
    },
    ...uploader_props
  },
  emit: ['update:value', 'uploaded'],

  mounted() {
    this.setExistingFile(this.value)
  },
  data() {
    return {
      new_file: null,
      existing_file: null,
      existing_filename: null,
      has_error: false
    }
  },
  watch: {
    value: function (newVal) {
      if (!newVal || newVal === DELETE_KEY) {
        this.existing_file = null
        this.new_file = null
      } else
        this.setExistingFile(newVal)
    },
    has_error: function (newVal) {
      if (newVal && this.$refs.modalCropper) {
        this.$refs.modalCropper.dismiss();
      }
    }
  },
  methods: {
    setExistingFile(file) {
      if (!this.new_file && this.preview && this.preview.length) {
        this.existing_file = this.preview
      } else {
        if (!this.isValidFileUrl(file)) return
        this.existing_file = file
        this.existing_filename = this.filename
        this.new_file = null
      }
      if (!this.existing_filename)
        this.existing_filename = this.value.split('?').shift().split('/').pop()
    }, async onFileChosen(file) {
      if (file) {
        this.setFile(file)
        if (!fileUtils.isImage(file)) return
        await this.$nextTick()

        if (this.cropper) {
          if (this.cropper === cropperTypes.circle) {
            const resizedFile = await this.resizeImage(file, 1000, 1000, {exact: true, padding: 200})
            await this.$nextTick()
            this.setFile(resizedFile)
            await this.delay(200)
            await this.$refs.modalCropper.open()
          } else {
            await this.$refs.modalCropper.open()
          }
        } else if (this.resize) {
          const resizedFile = await this.resizeImage(file, this.resize.max_width, this.resize.max_height)
          this.setFile(resizedFile)
        }
      }
    }, setFile(file) {
      this.has_error = false
      this.new_file = file
      this.existing_file = null
    }, onFileEdited(file) {
      this.setFile(file)
    }, onCropperDismiss(resetFile) {
      if (resetFile)
        this.new_file = null
    }, deleteFile() {
      this.new_file = null
      this.$emit('update:value', DELETE_KEY)
      this.$emit('uploaded', '')
    },
    getImageSizes() {
      // Try existing file first (PFilePreview)
      if (this.$refs.filePreview) {
        return this.$refs.filePreview.getImageSizes()
      }
      
      // Try new file (PFileUploader)
      if (this.$refs.fileUploader) {
        return this.$refs.fileUploader.getImageSizes()
      }
      
      return Promise.resolve(null)
    },
    ...uploader_methods,
  }
}
</script>